export var ProviderTypes;
(function (ProviderTypes) {
    ProviderTypes["google"] = "google";
    ProviderTypes["webSafe"] = "web-safe";
    ProviderTypes["system"] = "system";
})(ProviderTypes || (ProviderTypes = {}));
//# sourceMappingURL=types.js.map